import PatientProfileModel from './PatientProfileModel';

export default class StudentProfileModel extends PatientProfileModel {
  constructor(data) {
    super(data);
  }
}
